import { SubmissionPlacementTaskInfo } from '@common/types';
import { SubmissionPlacementTaskClient } from 'clients';
import { QueryKeys } from 'enums';
import { MutateProps } from './query/types';
import { useMutate } from './query/useMutate';

export function useMutateSubmissionPlacementTask(options?: MutateProps) {
  const { update: updateStatus } = useMutate<
    SubmissionPlacementTaskInfo,
    SubmissionPlacementTaskInfo,
    {},
    SubmissionPlacementTaskClient
  >({
    queryKey: QueryKeys.SubmissionPlacementTask,
    clientClass: SubmissionPlacementTaskClient,
    cancelInvalidation: options?.cancelInvalidation,
    updateOptions: { throwOnError: true },
  });

  return { updateStatus };
}
